import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { RemoveRedEye, Report } from '@mui/icons-material';
import { Button, Card, FormControl, FormLabel, IconButton, Input, Snackbar, Stack, Typography } from '@mui/joy';
import { useAuth } from '../context/authContext';

import '../styles/authentication.scss';
import LoadingSpinnerComponent from '../components/LoadingSpinnerComponent';

import logo from '../resources/logo.svg'
import footer_appinion from '../resources/footer_logo.png'

function AuthenticationComponent() {
    const { login, isAuthenticated, mcpAuth } = useAuth();

    let navigate = useNavigate();

    const [value, setValue] = React.useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showError, setShowError] = useState(false);
    const [showPass, setShowPass] = useState(false);

    useEffect(() => {
        if (isAuthenticated) {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('mcp') !== 'true') {
                navigate("/apps-list");
            }
        }
    }, [isAuthenticated, navigate]);

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        setLoading(true);

        const urlParams = new URLSearchParams(window.location.search);
        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());
        const userEmail = formJson.email.toString();

        try {
            await login(formJson.email.toString(), formJson.password.toString()).then(async () => {
                if (urlParams.get('mcp') === 'true') {
                    const state = urlParams.get('state');

                    // Chamar POST /mcp/auth para gerar authorization code
                    const code = await mcpAuth(userEmail, state || '');
                    const redirectUri = urlParams.get('redirect_uri');

                    // Redirecionar de volta para ChatGPT com código
                    window.location.href = `${redirectUri}?code=${code}&state=${state}`;
                } else {
                    navigate('/apps-list');
                }
            }).catch((error: any) => {
                setError(error.message);
                setShowError(true);
                setLoading(false);
            });

        } catch (error: any) {
            setError(error.message);
            setShowError(true);
            setLoading(false);
        }
    }

    return (
        <>
            {showError &&
                <Snackbar
                    variant="soft"
                    color="danger"
                    open={showError}
                    onClose={() => setShowError(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    startDecorator={<Report />}
                    endDecorator={
                        <Button
                            onClick={() => setShowError(false)}
                            size="sm"
                            variant="soft"
                            color="danger"
                        >
                            Dismiss
                        </Button>
                    }
                >
                    {error}
                </Snackbar>
            }
            <div className='container-fluid bg-cloudie p-5'>
                <div className='text-center'>
                    <a
                        href='/'>
                        <img
                            src={logo}
                            height={40 + 'px'}
                            alt='Appinion logo' />
                    </a>
                </div>
                <div className='mt-4 text-center'>
                    <Typography
                        level="title-lg"
                        sx={{
                            fontWeight: 'bold',
                            color: '#313131',
                            marginBottom: 1
                        }}>
                        Sign in
                    </Typography>
                    <Typography
                        level="body-sm"
                        component="h1">
                        Not a client yet?
                        <a href='/subscribe'>
                            <span className='underlined'> Sign up</span>
                        </a>
                    </Typography>
                </div>

                <Card
                    sx={{
                        mx: 'auto', // margin left & right
                        my: 4, // margin top & bottom
                        py: 5, // padding top & bottom
                        px: 5, // padding left & right
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        borderRadius: 'sm',
                        boxShadow: 'md',
                        maxWidth: 600
                    }}
                    variant="outlined"
                >
                    {loading ?
                        <LoadingSpinnerComponent />
                        :
                        <form
                            onSubmit={(event) => {
                                handleSubmit(event)
                            }}
                        >
                            <Stack
                                spacing={4}>
                                <FormControl>
                                    <FormLabel>Email</FormLabel>
                                    <Input
                                        // html input attribute
                                        name="email"
                                        type="email"
                                        required
                                        size='md'
                                    />
                                </FormControl>
                                <FormControl>
                                    <FormLabel>Password</FormLabel>
                                    <Input
                                        name="password"
                                        type={showPass ? "text" : "password"}
                                        placeholder="Type in here…"
                                        endDecorator={
                                            <IconButton
                                                onClick={() => setShowPass(!showPass)}>
                                                {
                                                    showPass ?
                                                        <RemoveRedEye></RemoveRedEye>
                                                        :
                                                        <RemoveRedEye></RemoveRedEye>
                                                }
                                            </IconButton>
                                        }
                                        value={value}
                                        onChange={(event) => setValue(event.target.value)}
                                    />
                                </FormControl>
                                <Button
                                    type='submit'
                                    sx={{ mt: 1 /* margin top */ }}>
                                    Sign in
                                </Button>
                                <a href='/forgot-password'>
                                    <Typography
                                        level="body-sm"
                                        sx={{
                                            color: 'primary',
                                            textAlign: 'center'
                                        }}>
                                        Forgot your password?
                                    </Typography>
                                </a>
                            </Stack>
                        </form>
                    }
                </Card>
            </div >
            <footer className='p-3 text-center'>
                <p className='legend light-iron'>© Appinion 2025. All rights reserved</p>
                <img className='ms-3' src={footer_appinion} alt="logo" style={{ height: 16 + 'px' }}></img>
                <ul className='navbar-nav ms-auto'>
                    <li className='nav-item'>
                    </li>
                </ul>
            </footer>
        </>
    );
}

export default AuthenticationComponent;